/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateScreenerLeadAdmissionFlagRequest } from './UpdateScreenerLeadAdmissionFlagRequest';
import {
    UpdateScreenerLeadAdmissionFlagRequestFromJSON,
    UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped,
    UpdateScreenerLeadAdmissionFlagRequestToJSON,
} from './UpdateScreenerLeadAdmissionFlagRequest';

/**
 * 
 * @export
 * @interface UpdateScreenerLeadAdmissionFlag200Response
 */
export interface UpdateScreenerLeadAdmissionFlag200Response {
    /**
     * 
     * @type {UpdateScreenerLeadAdmissionFlagRequest}
     * @memberof UpdateScreenerLeadAdmissionFlag200Response
     */
    data?: UpdateScreenerLeadAdmissionFlagRequest;
}

/**
 * Check if a given object implements the UpdateScreenerLeadAdmissionFlag200Response interface.
 */
export function instanceOfUpdateScreenerLeadAdmissionFlag200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateScreenerLeadAdmissionFlag200ResponseFromJSON(json: any): UpdateScreenerLeadAdmissionFlag200Response {
    return UpdateScreenerLeadAdmissionFlag200ResponseFromJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlag200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerLeadAdmissionFlag200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UpdateScreenerLeadAdmissionFlagRequestFromJSON(json['data']),
    };
}

export function UpdateScreenerLeadAdmissionFlag200ResponseToJSON(value?: UpdateScreenerLeadAdmissionFlag200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdateScreenerLeadAdmissionFlagRequestToJSON(value.data),
    };
}

